import { Link } from "react-router-dom";
import { SECTORS } from "../../lib/sectors";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-navy text-ivory/80 mt-0"
    >
      <div className="container-bharat py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="relative inline-flex items-center justify-center w-11 h-11 rounded-sm border border-gold/40 text-gold font-display">
                <span className="absolute inset-1 rounded-full ashoka-spokes opacity-90" />
                <span className="relative">B</span>
              </span>
              <span className="leading-tight">
                <span className="block font-serif-display text-2xl text-ivory">
                  Bharat Axis Advisory
                </span>
                <span className="block overline text-[0.6rem] text-gold/80">
                  Architecting the Next Era of Bharat
                </span>
              </span>
            </div>
            <p className="mt-8 max-w-md text-sm leading-relaxed text-ivory/70">
              Strategic advisory and transformation solutions for the
              institutions building India's next century — across healthcare,
              education, infrastructure, workforce and Digital Bharat.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-gold/80 mb-5">Sectors</p>
            <ul className="space-y-3 text-sm">
              {SECTORS.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/sectors/${s.slug}`}
                    className="hover:text-gold transition-colors"
                  >
                    {s.short}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="overline text-gold/80 mb-5">Firm</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="/#legacy" className="hover:text-gold">
                  Legacy
                </a>
              </li>
              <li>
                <a href="/#insights" className="hover:text-gold">
                  Insights
                </a>
              </li>
              <li>
                <a href="/#governance" className="hover:text-gold">
                  Governance
                </a>
              </li>
              <li>
                <a href="/#engage" className="hover:text-gold">
                  Engage
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="overline text-gold/80 mb-5">Contact</p>
            <p className="text-sm text-ivory/75 leading-relaxed">
              advisory@axisbharat.com
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-ivory/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-ivory/55">
          <p>
            © {new Date().getFullYear()} Bharat Axis Advisory. An institution
            built for Bharat's next century.
          </p>
          <p className="font-display tracking-[0.4em] text-gold/70">
            सत्यमेव जयते
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
